import { Controller } from "@hotwired/stimulus"

// Substance is words only. A picture pasted or dropped into the composer is
// turned away - quietly, with the reason - and the text that came with it,
// if any, is kept.
export default class extends Controller {
  static targets = ["note"]
  // The reason given, set by the page in the reader's language.
  static values = { note: { type: String, default: "Words only. That's the point." } }

  paste(event) {
    if (this.carriesFiles(event.clipboardData)) this.refuse(event)
  }

  dragover(event) {
    if (this.carriesFiles(event.dataTransfer)) event.preventDefault()
  }

  drop(event) {
    if (this.carriesFiles(event.dataTransfer)) this.refuse(event)
  }

  carriesFiles(data) {
    if (!data) return false
    if (data.files && data.files.length > 0) return true
    return Array.from(data.items || []).some((item) => item.kind === "file")
  }

  refuse(event) {
    event.preventDefault()
    if (!this.hasNoteTarget) return

    this.noteTarget.textContent = this.noteValue
    this.noteTarget.hidden = false
    clearTimeout(this.timer)
    this.timer = setTimeout(() => { this.noteTarget.hidden = true }, 2600)
  }

  disconnect() {
    clearTimeout(this.timer)
  }
}
